// src/components/classroom/LegacyP2PClassroom.jsx
/**
 * Legacy WebRTC P2P Classroom Component
 * Preserved behind feature flag until LiveKit is verified in production.
 */
import React from "react";
import WebRTCClassRoom from "../WebRTCClassRoom";

export default function LegacyP2PClassroom({
  roomId,
  role = "student",
  displayName = "Participant",
  guestToken,
  onClose,
  onParticipantJoin,
  allowStudentAudio = true,
  allowStudentVideo = false,
}) {
  return (
    <WebRTCClassRoom
      roomId={roomId}
      role={role}
      displayName={displayName}
      guestToken={guestToken}
      onClose={onClose}
      onParticipantJoin={onParticipantJoin}
      allowStudentAudio={allowStudentAudio}
      allowStudentVideo={allowStudentVideo}
    />
  );
}
